<template>
	<div>
		<div
			v-for="(accommodation, index) in cart.accommodation"
			:key="index"
			class="cart-list__item grid-x"
		>
			<div class="cell small-3 medium-2">
				<!-- Image -->
				<img
					class="cart-list__image"
					:src="
						accommodation.image
							? accommodation.image
							: 'https://r360-api.klappen.se/images/klappen_boende_fallback.jpg'
					"
					alt="cart image"
				/>
			</div>
			<div class="cell small-9 medium-2 cart-list__mobile-header">
				<!-- Head in mobile -->
				<span class="cart-list__item-no">
					{{ $t('accommodation.accommodation') }} {{ index + 1 }}
				</span>
				<span class="cart-list__heading cart-list__heading--small">
					<router-link
						:to="{
							name: 'accommodation',
							...urlToAccommodation(accommodation)
						}"
					>
						{{ accommodation.title }}
					</router-link>
					<LabelBox v-if="hasDiscount(accommodation)">
						<template>
							-{{ discountPrice(accommodation) }} {{ cart.currency }}
						</template>
					</LabelBox>
				</span>
			</div>

			<div class="cell small-12 medium-10">
				<!-- Buttons -->
				<div class="cart-list__buttons">
					<Button
						size="square"
						color="red"
						@click.native="
							() =>
								!accommodation.detlid
									? showRemoveProductModal(accommodation)
									: () => {}
						"
						:disabled="accommodation.detlid ? true : false"
					>
						<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M21.19 4.22l-1.41-1.41L12 10.59 4.22 2.81 2.81 4.22 10.59 12l-7.78 7.78 1.41 1.41L12 13.41l7.78 7.78 1.41-1.41L13.41 12l7.78-7.78z"/></svg>
					</Button>
					<router-link
						v-if="!accommodation.detlid"
						:to="{
							name: 'accommodation',
							...urlToAccommodation(accommodation)
						}"
					>
						<Button size="small" color="dark">
							{{ $t('cart.change') }}
						</Button>
					</router-link>
				</div>

				<!-- Card -->
				<div class="cart-list__card">
					<!-- Head -->
					<div class="cart-list__head grid-x">
						<div class="cell small-12 medium-8">
							<span class="cart-list__item-no">
								{{ $t('accommodation.accommodation') }} {{ index + 1 }}
							</span>
							<span class="cart-list__heading">
								<router-link
									:to="{
										name: 'accommodation',
										...urlToAccommodation(accommodation)
									}"
								>
									{{ accommodation.title }}
								</router-link>
								<LabelBox v-if="hasDiscount(accommodation) && !cart.resvid">
									<template>
										-{{ discountPrice(accommodation) }} {{ cart.currency }}
									</template>
								</LabelBox>
							</span>
						</div>
					</div>

					<!-- Body -->
					<div class="cart-list__body">
						<div class="cart-list__table">
							<div class="cart-list__table-item grid-x">
								<div class="cart-list__table-label cell small-9">
									<!-- Dates -->
									<span
										v-if="
											accommodation.arrdate != null ||
											accommodation.depdate != null
										"
									>
										{{
											formatDateSpan(
												accommodation.arrdate,
												accommodation.depdate
											)
										}}
									</span>

									<!-- Number of people -->
									<span class="cart-list__people-list">
										<span v-if="accommodation.noofchild5 > 0">
											{{ accommodation.noofchild5 }}
											<span v-if="accommodation.noofchild5 === 1">
												{{ $t('accommodation.adult') }}
											</span>
											<span v-else>{{ $t('accommodation.adults') }}</span>
										</span>
										<span v-if="accommodation.noofchild3 > 0">
											{{ accommodation.noofchild3 }}
											<span v-if="accommodation.noofchild3 === 1">
												{{ $t('accommodation.youth') }}
											</span>
											<span v-else>{{ $t('accommodation.youths') }}</span>
										</span>
										<span v-if="accommodation.noofchild2 > 0">
											{{ accommodation.noofchild2 }}
											<span v-if="accommodation.noofchild2 === 1">
												{{ $t('accommodation.child') }}
											</span>
											<span v-else>{{ $t('accommodation.children') }}</span>
										</span>
										<button
											v-if="accommodation.allowmodify"
											class="cart-list__change-btn"
											@click="toggleChangePeople(accommodation)"
										>
											{{
												showChangePeople
													? `(${$t('cart.done')})`
													: `(${$t('cart.change')})`
											}}
										</button>
									</span>
									<div v-if="showChangePeople" class="change-people__wrapper">
										<div class="change-people__loading">
											<Loading v-if="loading" :dark="true" />
										</div>
										<div class="change-people__column">
											<NumberComponent
												:label="$t('search.numberLabelChildren')"
												:underlabel="$t('search.numberLabelChildrenYears')"
												:initalValue="accommodation.noofchild2"
												:disablePlus="
													accommodation.sleepingArrangementBeds <= totalPeaple()
												"
												:minNumber="
													accommodation.type &&
													accommodation.type.toUpperCase() == 'HOTELL' &&
													accommodation.detlid
														? accommodation.original_noofchild2
														: 0
												"
												@number-input="
													(val, id) => {
														noofchild2 = val
													}
												"
											/>
										</div>
										<div class="change-people__column">
											<NumberComponent
												:label="$t('search.numberLabelYouth')"
												:underlabel="$t('search.numberLabelYouthYears')"
												:initalValue="accommodation.noofchild3"
												:disablePlus="
													accommodation.sleepingArrangementBeds <= totalPeaple()
												"
												:minNumber="
													accommodation.type &&
													accommodation.type.toUpperCase() == 'HOTELL' &&
													accommodation.detlid
														? accommodation.original_noofchild3
														: 0
												"
												@number-input="
													(val, id) => {
														noofchild3 = val
													}
												"
											/>
										</div>
										<div class="change-people__column">
											<NumberComponent
												:label="$t('search.numberLabelAdult')"
												:underlabel="$t('search.numberLabelAdultYears')"
												:initalValue="accommodation.noofchild5"
												:disablePlus="
													accommodation.sleepingArrangementBeds <= totalPeaple()
												"
												:minNumber="
													accommodation.type &&
													accommodation.type.toUpperCase() == 'HOTELL' &&
													accommodation.detlid
														? accommodation.original_noofchild5
														: 1
												"
												@number-input="
													(val, id) => {
														noofchild5 = val
													}
												"
											/>
										</div>
									</div>
									<!-- Included addons -->
									<div
										v-if="
											mandatoryAddons(index).length > 0 ||
											(accommodation.campaignCode &&
												accommodation.campaignCode != '') ||
											(!accommodation.campaignCode &&
												accommodation.promotion &&
												accommodation.promotion.promotioncode &&
												accommodation.promotion.promotioncode != '')
										"
										class="cart-list__addon-labels"
									>
										<span class="cart-list__addon-labels-headline">
											{{ $t('accommodation.including') }}:
										</span>

										<ul>
											<template v-for="addon in mandatoryAddons(index)">
												<li :key="mandatoryAddons(index).indexOf(addon)">
													{{ addon }}
												</li>
											</template>

											<li
												v-if="
													accommodation.campaignCode &&
													accommodation.campaignCode != ''
												"
											>
												{{ $t('accommodation.includingCampaignCode') }}:
												{{ accommodation.campaignCode }}
											</li>
											<li
												v-if="
													!accommodation.campaignCode &&
													accommodation.promotion &&
													accommodation.promotion.promotioncode &&
													accommodation.promotion.promotioncode != ''
												"
											>
												{{ $t('accommodation.includingCampaignCode') }}:
												{{ accommodation.promotion.promotioncode }}
											</li>
										</ul>
									</div>
								</div>
								<div
									class="cart-list__table-price cell small-3"
									v-if="hasDiscount(accommodation)"
								>
									<div class="price">
										<div v-if="cart.resvid">
											{{ convertPrice(accommodation.price) }}
											{{ accommodation.currency }}
										</div>
										<div v-else class="price__discount">
											{{ convertPrice(accommodation.price) }}
											{{ accommodation.currency }}
										</div>
										<div class="price__full" v-if="!cart.resvid">
											<span class="price__label">
												{{ $t('cart.fullPrice') }}
											</span>
											{{ convertPrice(accommodation.ordinaryprice) }}
											{{ accommodation.currency }}
										</div>
									</div>
								</div>
								<div class="cart-list__table-price cell small-3" v-else>
									{{ convertPrice(accommodation.price) }}
									{{ accommodation.currency }}
								</div>
							</div>
							<!-- Optional addons -->
							<div
								class="cart-list__table-head grid-x cart-list__table-head--with-upper-margin"
							>
								<div class="cell small-9 medium-8">
									<span class="cart-list__addon-heading">
										{{ $t('accommodation.addonListLabel') }}
									</span>
								</div>
								<div class="cell medium-2 show-for-medium">
									<span>{{ $t('cart.price') }}</span>
								</div>
								<div class="cell small-3 medium-2">
									<span>{{ $t('cart.total') }}</span>
								</div>
							</div>

							<AccommodationAddon
								v-for="(addon, index) in accommodation.addons"
								:key="addon.id"
								:description="addon.arttext"
								:price="addon.curraprice"
								:currency="addon.currency"
								:inputType="addon.type_input"
								:poollid="addon.extraspoollid"
								:mandatory="addon.mandatory_web"
								:maxQty="addon.max_qty"
								:minQty="addon.min_qty"
								:original_qty="addon.original_qty"
								:objectId="accommodation.objectId"
								:isChecked="addon.qty"
								:extraspoollid="addon.extraspoollid"
								:quantity="addon.qty"
								:tooltipTitle="addon.arttext"
								:tooltipText="addon.longdescription"
								:lastChild="index === accommodation.addons.length - 1"
								:allowcancellation="addon.allowcancellation"
								:allowmodify="addon.allowmodify"
								:detlid="accommodation.detlid"
								@clicked="getChildAddon"
							/>
						</div>
					</div>

					<!-- Foot -->
					<div class="cart-list__foot">
						<div class="cart-list__price">
							<span class="cart-list__heading">
								{{ accAndAddonPrice(accommodation) }}
								{{ accommodation.currency }}
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- Modal: Remove product -->
		<Modal
			v-show="showModal"
			:disableClose="true"
			:maxWidth="640"
			:heading="$t('cart.remove')"
			:text="modalAccomodation.title"
			:closeCta="true"
			:closeCtaText="$t('cart.close')"
			@close="showModal = false"
		>
			<template v-slot:buttons>
				<Button @click.native="removeAccommodation(modalAccomodation)">
					{{ $t('cart.remove') }}
				</Button>
			</template>
		</Modal>
	</div>
</template>

<script>
import store from '../../vueX/store'
import mixin from '../../mixin'

import Button from '../atoms/Button'
import Loading from '../atoms/Loading'
import NumberComponent from '../atoms/NumberComponent'
import LabelBox from '../atoms/LabelBox'
import AccommodationAddon from '../molecules/AccommodationAddon'
import Modal from '../molecules/Modal'

export default {
	name: 'CartAccommodation',
	store,
	mixins: [mixin],
	components: {
		Button,
		AccommodationAddon,
		NumberComponent,
		LabelBox,
		Loading,
		Modal
	},
	data() {
		return {
			showModal: false,
			showChangePeople: false,
			noofchild2: 0,
			noofchild3: 0,
			noofchild5: 0,
			loading: false,
			modalAccomodation: {}
		}
	},
	props: {},
	computed: {
		cart() {
			return store.state.cart
		}
		// hasDiscount() {
		// 	for (let index = 0; index < this.cart.accommodation.length; index++) {
		// 		const accommodation = this.cart.accommodation[index]

		// 		if (
		// 			accommodation.campaignCode !== undefined &&
		// 			accommodation.campaignCode !== ''
		// 		) {
		// 			return true
		// 		}
		// 	}

		// 	return false
		// }
	},
	methods: {
		totalPeaple() {
			return (
				parseInt(this.noofchild2) +
				parseInt(this.noofchild3) +
				parseInt(this.noofchild5)
			)
		},
		totalDiscountPrice() {
			let price = 0

			for (let index = 0; index < this.cart.accommodation.length; index++) {
				const accommodation = this.cart.accommodation[index]

				if (
					accommodation.campaignCode !== undefined &&
					accommodation.campaignCode !== ''
				) {
					price += accommodation.ordinaryprice - accommodation.price
				}
			}

			return price
		},
		hasDiscount(accommodation) {
			if (
				(accommodation.promotion !== undefined &&
					accommodation.promotion !== null &&
					accommodation.promotion.promotioncode !== '') ||
				(accommodation.campaignCode !== undefined &&
					accommodation.campaignCode !== null &&
					accommodation.campaignCode !== '')
			) {
				return true
			}

			return false
		},
		discountPrice(accommodation) {
			return accommodation.ordinaryprice - accommodation.price
		},
		toggleChangePeople(accommodation) {
			if (!this.showChangePeople) {
				this.showChangePeople = true
				this.loading = false

				this.noofchild2 = accommodation.noofchild2
				this.noofchild3 = accommodation.noofchild3
				this.noofchild5 = accommodation.noofchild5
			} else {
				this.loading = false
				if (
					accommodation.noofchild2 !== this.noofchild2 ||
					accommodation.noofchild3 !== this.noofchild3 ||
					accommodation.noofchild5 !== this.noofchild5
				) {
					this.loading = true

					store
						.dispatch('GET_ACCOMMODATIONS_WITH_DATES', {
							poollid: accommodation.poollid,
							unitlid: accommodation.unitlid,
							endDate: accommodation.depdate,
							startDate: accommodation.arrdate,
							campaignCode: accommodation.campaignCode,
							amountChildren: this.noofchild2,
							amountYouths: this.noofchild3,
							amountAdults: this.noofchild5,
							checkPrice: true
						})
						.then(success => {
							if (success && Array.isArray(success) && success.length) {
								store.dispatch('CHANGE_ACCOMMODATION_IN_CART', {
									accommodation: accommodation,
									people: {
										noofchild2: this.noofchild2,
										noofchild3: this.noofchild3,
										noofchild5: this.noofchild5
									},
									price: success[0].price,
									ordinaryprice: success[0].ordinaryprice
								})
							}
							this.loading = false
							this.showChangePeople = false
						})
				} else {
					this.showChangePeople = false
				}
			}
		},
		accAndAddonPrice(item) {
			let finalAmount = Number()
			let addonPrice = Number()
			const accPrice = Number(item.price)

			item.addons.filter(addon => {
				if (addon.mandatory_web === false) {
					let newPrice
					newPrice = addon.aprice * addon.qty
					addonPrice = Number(addonPrice) + Number(newPrice)
				}
			})
			finalAmount = addonPrice + accPrice
			return new Intl.NumberFormat(this.$t('currency')).format(finalAmount)
		},
		//To do - move to action?
		showRemoveProductModal(accommodation) {
			this.modalAccomodation = accommodation
			this.showModal = true
		},
		urlToAccommodation(accommodation) {
			return {
				params: {
					id: `${accommodation.title.replace(/ /g, '-')}_${
						accommodation.poollid
					}_${accommodation.unitlid}`
				},
				query: {
					s: accommodation.arrdate ? accommodation.arrdate : undefined,
					e: accommodation.depdate ? accommodation.depdate : undefined,
					c: accommodation.noofchild2 ? accommodation.noofchild2 : undefined,
					y: accommodation.noofchild3 ? accommodation.noofchild3 : undefined,
					a: accommodation.noofchild5 ? accommodation.noofchild5 : undefined,
					cc: accommodation.campaignCode
				}
			}
		},
		removeAccommodation(accommodation) {
			store.dispatch('REMOVE_ACCOMMODATION_FROM_CART', accommodation)
			this.showModal = false
		},
		getChildAddon(value, poolid, objectId, productDetlid) {
			const intValue = Number(value)
			let changedAddons = {}
			store.state.cart.accommodation.filter(item => {
				if (
					item['objectId'] == objectId ||
					(item.detlid && item.detlid == productDetlid)
				) {
					changedAddons = item.addons.map(obj =>
						obj.extraspoollid == poolid ? { ...obj, qty: intValue } : obj
					)
					return item
				}
			})

			store
				.dispatch('SET_CART_ADDONS', {
					addons: changedAddons,
					objectId: objectId,
					productDetlid: productDetlid
				})
				.then(() => {
					this.cart.accommodation = store.state.cart.accommodation
				})
		},
		mandatoryAddons(productId) {
			const mandatoryAddonsList = []
			const thisProduct = this.cart.accommodation[productId]

			const totalPeople =
				parseInt(thisProduct.noofchild2) +
				parseInt(thisProduct.noofchild3) +
				parseInt(thisProduct.noofchild5)

			//PLUS
			if (thisProduct.plusaccommodation) {
				mandatoryAddonsList.push(this.$t('accommodation.plusLabel'))
			}

			//Skipass
			thisProduct.addons.forEach(function (addon) {
				if (addon.mandatory_web === true && addon.resvtypelid === 1001) {
					mandatoryAddonsList.push(addon.qty + ' ' + addon.arttext)
				}
			})

			//Breakfast
			if (thisProduct.breakfastincluded) {
				mandatoryAddonsList.push(
					totalPeople + ' ' + this.$t('accommodation.breakfast') + '*'
				)
			}

			//Linen
			if (thisProduct.linensetincluded) {
				mandatoryAddonsList.push(totalPeople + ' ' + this.$t('cart.linenSet'))
			}

			//Departure cleaning
			if (thisProduct.departurecleaning) {
				mandatoryAddonsList.push(this.$t('cart.departureCleaning'))
			}

			return mandatoryAddonsList
		}
	}
}
</script>

<style scoped lang="scss">
.change-people {
	&__wrapper {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		background-color: $colorPrimary1;
		border-radius: 5px;
		padding: 15px;
		margin: 10px 0;
		position: relative;
	}

	&__loading {
		position: absolute;
		top: 20px;
		right: 20px;
	}

	&__column {
		display: flex;
		flex-direction: column;
		margin: 0 15px;
	}

	&__title {
		color: $colorGrey8;
		font-size: 15px;
	}

	&__age {
		margin-bottom: 10px;
	}
}
.price {
	// ToDo: refactor into common atom for all .price thing used in this project
	&__discount {
		color: #e15b5b;
	}
	&__full {
		font-size: 13px;
		line-height: 20px;

		.price__label {
			color: $colorPrimary5;
		}
	}
}
.cart-list__heading {
	display: flex;
	align-items: center;

	.label-box {
		margin-left: 5px;
	}
}
</style>
